import SingleSignOnFormModeContextProvider from '@/Providers/SingleSignOnFormModeContextProvider';
import WebAuthnContextProvider from '@/Providers/WebAuthnContextProvider';
import WechatSignIn from '@/components/WechatSignIn';
import PageMeta from '@/shared/components/PageMeta';
import {
  isContextualSignInEmbedded,
  type ContextualSignInPage as PageSettings,
} from '@/utils/contextual-sign-in-page';

const ContextualSignInPage = ({ settings }: { readonly settings: PageSettings }) => (
  <>
    <PageMeta titleKey="description.sign_in_to_your_account" />
    <WebAuthnContextProvider>
      <SingleSignOnFormModeContextProvider>
        <WechatSignIn settings={settings} isEmbedded={isContextualSignInEmbedded(settings)} />
      </SingleSignOnFormModeContextProvider>
    </WebAuthnContextProvider>
  </>
);
export default ContextualSignInPage;
